import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AvatarModule } from "ngx-avatars";
import {
  API_URLS,
  AVATAR_BG_COLOR,
  AVATAR_FG_COLOR,
} from "src/app/config/app.constants";

@Component({
  selector: "app-previous-groomer-list",
  standalone: true,
  imports: [CommonModule, AvatarModule],
  templateUrl: "./previous-groomer-list.component.html",
  styleUrl: "./previous-groomer-list.component.css",
})
export class PreviousGroomerListComponent {
  @Input() set fromParent(value) {
    this.previousGroomer = value?.previousGroomer;
    this.previousGroomerAvailableDates = value?.previousGroomerAvailableDates;
    this.valuesForCheckPlan = value?.valuesForCheckPlan;
    this.selectedGroomingPlan = value?.selectedGroomingPlan;
    this.selectedOutpostId = value?.selectedOutpostId;
    this.cdr.markForCheck();
  }
  @Output() continueGroomer = new EventEmitter<any>();
  previousGroomer;
  previousGroomerAvailableDates;
  previousGroomerSelectedDate: Date;
  valuesForCheckPlan: any = "";
  selectedGroomingPlan;
  selectedOutpostId;
  imagePath = API_URLS.FILE_PATH_USER_PROFILE;
  avatar_fg_color = AVATAR_FG_COLOR;
  avatar_bg_color = AVATAR_BG_COLOR;

  constructor(
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {}

  onPreviousGroomerDateSelect(date) {
    this.previousGroomerSelectedDate = date;
  }
  /* 
  loadMoreAvailableDate() {
    const dateOfGrooming = Utils.getDateFormat(
      new Date(
        this.previousGroomerAvailableDates[
          this.previousGroomerAvailableDates.length - 1
        ]
      )
    );
    const groomingDate =
      dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0];
    this.http
      .post(
        API_URLS.GET_PREVIOUS_GROOMER_DETAILS,
        {
          schedule_date: groomingDate,
          pet_id: this.valuesForCheckPlan["selectedPetId"],
          type: "regular",
          selected_styles: this.selectedGroomingPlan.id,
          grooming_plan_id: this.selectedGroomingPlan.id,
          pet_size_id: this.valuesForCheckPlan["selectedPetNewSize"],
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe((response) => {
        if (response.type === "success" && response.code === 200) {
          if (response.data) {
            Array.prototype.push.apply(
              this.previousGroomerAvailableDates,
              response.data.dates
            );
          }
        }
      });
  } */
  OnPreviousGroomerContinue() {
    if (this.previousGroomerSelectedDate) {
      this.continueGroomer.emit({
        groomingDate: new Date(this.previousGroomerSelectedDate),
      });
      this.activeModal.close();
    }
  }
}
